import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=e2775d6c&"
import script from "./PrivacyDialog.vue?vue&type=script&lang=js&"
export * from "./PrivacyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports